import { render, staticRenderFns } from "./JsonExcel.vue?vue&type=template&id=4abaf86a&"
import script from "./JsonExcel.vue?vue&type=script&lang=ts&"
export * from "./JsonExcel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports